import React, { useCallback } from 'react';
import { array, bool, func, shape } from 'prop-types';

import { groupBy } from 'lodash';

import TagSelect from '../../components/FormFields/TagSelect';

const CallSourcesFilter = ({
    disabled,
    callSourcesFilter,
    onChangeCallSourcesFilter,
    ...props
}) => {
    const changeHandler = (defaultValues = {}) => {
        return (event) => {
            const { value } = event.target;
            const groupedValues = groupBy(value, 'type');
            const newValues = { ...defaultValues };
            Object.entries(groupedValues).forEach(([type, value]) => {
                newValues[type] = value;
            });
            onChangeCallSourcesFilter(newValues);
        };
    };

    const handleChange = useCallback(
        changeHandler({
            callSources: []
        })
    );

    const options = [
        {
            items: [
                {
                    id:   0,
                    name: 'API'
                },
                {
                    id:   1,
                    name: 'Email'
                },
                {
                    id:   2,
                    name: 'Home'
                },
                {
                    id:   3,
                    name: 'Rule'
                },
                {
                    id:   4,
                    name: 'Signature'
                },
                {
                    id:   5,
                    name: 'Other'
                }
            ],
            name:      'Request Sources',
            itemProps: {
                type: 'callSources'
            }
        }
    ];

    const value = [...callSourcesFilter.callSources];

    return (
        <TagSelect
            disabled={disabled}
            grouped
            kickerText="Add any combination of Request Sources to filter by these items."
            label="Request Sources"
            name={undefined}
            onChange={handleChange}
            options={options}
            placeholder="Add Request Source"
            value={value}
            {...props}
        />
    );
};

CallSourcesFilter.defaultProps = {
    callSourcesFilter: {
        callSources: []
    },
    disabled:                  false,
    onChangeCallSourcesFilter: () => {}
};

CallSourcesFilter.propTypes = {
    callSourcesFilter: shape({
        callSources: array.isRequired
    }),
    disabled:                  bool,
    onChangeCallSourcesFilter: func.isRequired
};

export default CallSourcesFilter;
